<div class="grid grid-cols-1 gap-4">
  <!-- Versandkonfiguration: gilt fuer normalen Versand UND Staging-Versand.
       Bei PickPoint werden Staging-Artikel passiv an die PickPoint-Adresse
       mitversandt; bei allen anderen Versandtypen laeuft Staging als
       Standard-Technikerversand. -->
  <div>
    <hawk-operation-shipping-config
      [operationId]="operationId"
      formHeading="Versandkonfiguration"
      emptyLabel="Standard (Parsing)"
      createButtonLabel="Versandkonfiguration setzen"
      [ticketStoreId]="ticketStoreId"
      [projectId]="projectId"
      [ticketLat]="ticketLat"
      [ticketLng]="ticketLng"
      [referenceDate]="referenceDate"
      [operationTechnicianId]="operationTechnicianId"
      [refreshKey]="activeConfigRefreshKey()"
      (configChanged)="onActiveConfigChanged($event)"
    />
    <hawk-operation-archived-shipping-configs
      [operationId]="operationId"
      [refreshKey]="archivedRefreshKey()"
    />
  </div>

  <!-- Versand-Section: Versand-Artikel mit Anzeige der bereits versandten Mengen.
       Items bleiben editierbar, auch wenn Teilversand schon stattgefunden hat —
       Backend erzwingt: Quantity nicht unter already_shipped_quantity, kein
       Loeschen wenn schon versandt. Add bleibt jederzeit erlaubt (Nachversand). -->
  <section class="bm-card bm-card-sm bm-card-body bm-card-border border-base-300">
    <div class="flex items-center justify-between">
      <h3 class="bm-card-title text-sm">
        Versand
        @if (versandRequirements().length > 0) {
          <span class="bm-badge bm-badge-xs bm-badge-warning ml-1">{{ versandRequirements().length }}</span>
        }
      </h3>
      <div class="flex items-center gap-1">
        @if (versandRequirements().length === 0) {
          <button class="bm-btn bm-btn-info bm-btn-xs"
                  [disabled]="parsingInProgress()"
                  (click)="parseFromDescription()"
                  title="Erzeugt Versand-Artikel aus der Auftragsbeschreibung (Legacy-Format)">
            @if (parsingInProgress()) {
              Parsing...
            } @else {
              Aus Auftragsbeschreibung parsen
            }
          </button>
        }
        <button class="bm-btn bm-btn-ghost bm-btn-xs" (click)="openAdd('VERSAND')">+ Hinzufügen</button>
      </div>
    </div>

    @if (versandRequirements().length > 0) {
      @for (req of versandRequirements(); track req.id) {
        @let alreadyShipped = req.already_shipped_quantity || 0;
        @let fullyShipped = alreadyShipped >= req.quantity;
        @let partiallyShipped = alreadyShipped > 0 && !fullyShipped;
        <div
          class="flex items-center gap-2 rounded px-3 py-1.5 text-sm transition-colors cursor-pointer hover:bg-base-300"
          [class.bg-base-200]="!fullyShipped && !partiallyShipped"
          [class.bg-info]="partiallyShipped"
          [class.text-info-content]="partiallyShipped"
          [class.bg-success]="fullyShipped"
          [class.text-success-content]="fullyShipped"
          (click)="openEdit(req)"
        >
          <span class="font-medium">{{ req.quantity }}x</span>
          <span class="flex-1">{{ req.article_template_description || req.free_text }}</span>
          @if (alreadyShipped > 0) {
            <span class="bm-badge bm-badge-xs"
                  [class.bm-badge-success]="fullyShipped"
                  [class.bm-badge-info]="!fullyShipped">
              {{ alreadyShipped }}/{{ req.quantity }} versandt
            </span>
          }
          @if (alreadyShipped === 0) {
            <button
              class="bm-btn bm-btn-ghost bm-btn-xs bm-btn-square"
              (click)="deleteRequirement(req); $event.stopPropagation()"
            >
              <svg xmlns="http://www.w3.org/2000/svg" class="w-3.5 h-3.5" viewBox="0 0 24 24"
                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
              </svg>
            </button>
          }
        </div>
      }
    } @else {
      <span class="text-xs text-base-content/50">Kein Versandartikel definiert</span>
    }
  </section>

  <!-- Staging-Section: Staging-Artikel sind jederzeit editierbar. Staging-
       Versand laeuft separat ueber Wochenpensum-Verteilung in der LagerApp;
       Mengen-Aenderungen wirken auf den noch ausstehenden Versand. -->
  <section class="bm-card bm-card-sm bm-card-body bm-card-border border-base-300">
    <div class="flex items-center justify-between">
      <h3 class="bm-card-title text-sm">
        Staging
        @if (stagingRequirements().length > 0) {
          <span class="bm-badge bm-badge-xs bm-badge-info ml-1">{{ stagingRequirements().length }}</span>
        }
      </h3>
      <button class="bm-btn bm-btn-ghost bm-btn-xs" (click)="openAdd('STAGING')">+ Hinzufügen</button>
    </div>

    @if (stagingRequirements().length > 0) {
      @for (req of stagingRequirements(); track req.id) {
        <div
          class="flex items-center gap-2 bg-base-200 rounded px-3 py-1.5 text-sm transition-colors cursor-pointer hover:bg-base-300"
          (click)="openEdit(req)"
        >
          <span class="font-medium">{{ req.quantity }}x</span>
          <span class="flex-1">{{ req.article_template_description || req.free_text }}</span>
          <button
            class="bm-btn bm-btn-ghost bm-btn-xs bm-btn-square"
            (click)="deleteRequirement(req); $event.stopPropagation()"
          >
            <svg xmlns="http://www.w3.org/2000/svg" class="w-3.5 h-3.5" viewBox="0 0 24 24"
              fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        </div>
      }
    } @else {
      <span class="text-xs text-base-content/50">Kein Staging-Artikel definiert</span>
    }
  </section>

  <!-- Modal-Overlay (geteilt fuer beide Sections) -->
  @if (showModal()) {
    <div class="fixed inset-0 z-50 flex items-center justify-center bg-black/40" (mousedown)="onBackdropClick($event)">
      <div class="bg-base-100 rounded-lg shadow-xl w-full max-w-md mx-4 p-5 flex flex-col gap-4">
        <h3 class="font-bold text-base">
          {{ editingRequirement() ? (formActionType === "STAGING" ? "Staging-Artikel bearbeiten" : "Versand-Artikel bearbeiten")
                                   : (formActionType === "STAGING" ? "Staging-Artikel hinzufügen" : "Versand-Artikel hinzufügen") }}
        </h3>

        <!-- Menge + Artikelvorlage in einer Zeile -->
        <div class="flex gap-3 items-start">
          <div class="w-24 shrink-0">
            <label class="bm-label text-xs mb-1">Menge</label>
            <input
              type="number"
              class="bm-input bm-input-sm w-full"
              [(ngModel)]="formQuantity"
              [min]="formMinQuantity()"
            />
            @if (formMinQuantity() > 1) {
              <span class="text-xs opacity-60 mt-1 block">
                Mind. {{ formMinQuantity() }} (bereits versandt)
              </span>
            }
          </div>

          <div class="flex-1 min-w-0">
            <label class="bm-label text-xs mb-1">
              @if (formActionType === "STAGING") {
                Artikelvorlage
              } @else {
                Artikelvorlage/Freitext
              }
            </label>
            <div class="relative">
              @if (formActionType === "STAGING") {
                <select
                  class="bm-select bm-select-sm w-full"
                  [(ngModel)]="formStagingTemplateId"
                  (ngModelChange)="onStagingTemplateSelect($event)"
                >
                  <option [ngValue]="null">Artikelvorlage wählen...</option>
                  @for (tpl of stagingTemplates(); track tpl.id) {
                    <option [ngValue]="tpl.id">{{ tpl.description }}</option>
                  }
                </select>
              } @else {
                <input
                  type="text"
                  class="bm-input bm-input-sm w-full"
                  [(ngModel)]="formSearchText"
                  (input)="onSearchInput()"
                  (blur)="onSearchBlur()"
                  placeholder="Artikelvorlage suchen oder Freitext..."
                />
                @if (searchResults().length > 0) {
                  <div class="absolute z-10 w-full mt-1 border border-base-300 rounded bg-base-100 shadow-lg max-h-40 overflow-y-auto">
                    @for (result of searchResults(); track result.id) {
                      <div
                        class="px-3 py-1.5 text-sm cursor-pointer hover:bg-base-200"
                        (mousedown)="selectTemplate(result)"
                      >
                        {{ result.description }}
                        @if (result.part_nr) {
                          <span class="text-base-content/50">({{ result.part_nr }})</span>
                        }
                      </div>
                    }
                  </div>
                }
              }
            </div>
          </div>
        </div>

        <!-- Aktionen -->
        <div class="flex gap-2 justify-end pt-2 border-t border-base-200">
          <button class="bm-btn bm-btn-ghost bm-btn-sm" (click)="closeModal()">Abbrechen</button>
          <button class="bm-btn bm-btn-primary bm-btn-sm" [disabled]="!canSave()" (click)="saveRequirement()">
            Speichern
          </button>
        </div>
      </div>
    </div>
  }
</div>
